import { getBasePath } from '@prophecy/utils/history';

export function redirectParentToUrl(url: string) {
  const baseUrl = `${window.location.origin}${getBasePath()}`;

  if (!url.startsWith(baseUrl)) url = `${baseUrl}${url}`;

  window.top?.postMessage({ type: 'ProphecyAppSignup', url }, '*');
}
